// * As per https://docs.anthropic.com/en/docs/about-claude/models/overview, some models might not be available on Bedrock or vice-versa
export enum LLMModelId {
  Claude30Haiku = 'claude-3-haiku',
  Claude35Sonnet = 'claude-3.5-sonnet',
  Claude35SonnetV2 = 'claude-3.5-sonnet-v2',
  Claude35Haiku = 'claude-3.5-haiku',
  Claude37Sonnet = 'claude-3.7-sonnet',
  Claude40Sonnet = 'claude-4.0-sonnet',
  Claude40Opus = 'claude-4.0-opus',
  Claude45Sonnet = 'claude-4.5-sonnet',
  Claude46Opus = 'claude-4.6-opus',
  Claude46Sonnet = 'claude-4.6-sonnet',
}

// * While the default is bedrock we want support for anthropic
export enum LLMModelType {
  Anthropic = 'anthropic',
  Bedrock = 'bedrock',
}

export const DEFAULT_VECTOR_MATCH_BUTTON_TEXT =
  'Klik hier voor meer informatie';

export const DEFAULT_LLM_MODEL_ID = LLMModelId.Claude46Sonnet; // * Current default as of March 26 2026
// * By default we want to run bedrock as of December 10th 2025
export const DEFAULT_LLM_MODEL_TYPE = LLMModelType.Bedrock;
export const DEFAULT_CLAUDE_TOKEN_LIMIT = 4096;

export enum LLMCostOperationName {
  PSN = 'PSN',
  HOT_TOPIC = 'hot-topic',
  SENTIMENT = 'sentiment',
  ARTICLE_ARCHITECT = 'article-architect',
  BRAIN_TEST = 'brain-test',
  MULTILINGUAL_TRANSLATION = 'multilingual-translation',
  EMAIL_AI_STUDIO = 'email-ai-studio',
  CONTACT_LOOKUP = 'contact-lookup',
  INTENT_CHECK = 'intent-check',
  PII_ANONYMIZATION = 'pii-anonymization',
}

export enum LLMCostCountType {
  WORDS = 'words',
  TOKENS = 'tokens',
}

export enum LLMCostTrigger {
  HOT_TOPIC_DAILY_SCHEDULER = 'hot-topic-daily-scheduler', // To track costs from daily scheduler runs for hot topic generation
  HOT_TOPIC_WEEKLY_SCHEDULER = 'hot-topic-weekly-scheduler', // To track costs from weekly scheduler runs for hot topic generation
  HOT_TOPIC_REGENERATE = 'hot-topic-regenerate', // When a super admin clicks regenerate button on the Hot Topics settings page
  HOT_TOPIC_WEEKLY_EXPORT = 'hot-topic-weekly-export', // To track costs from weekly export runs for hot topic generation
  HOT_TOPIC_REAL_TIME_CLASSIFICATION = 'hot-topic-real-time-classification', // Real-time hot-topic classifier that runs once per LLM block call
  SENTIMENT_REAL_TIME_CLASSIFICATION = 'sentiment-real-time-classification', // Real-time sentiment classifier that runs once per LLM block call
  ARTICLE_ARCHITECT_DOCUMENT_UPLOAD = 'article-architect-document-upload',
  ARTICLE_ARCHITECT_TRAIN_AI = 'article-architect-train-ai',
  ARTICLE_ARCHITECT_BCC_EMAIL = 'article-architect-bcc-email',
  ARTICLE_ARCHITECT_CONFLICT_MERGE = 'article-architect-conflict-merge',
  ARTICLE_ARCHITECT_CONFLICT_DETECTION = 'article-architect-conflict-detection',
  ARTICLE_ARCHITECT_CONFLICT_SCAN = 'article-architect-conflict-scan',
  ARTICLE_ARCHITECT_BACKFILL = 'article-architect-backfill', // TopDesk YTD/weekly backfill generation phase
  BRAIN_TEST_EXPERIMENT = 'brain-test-experiment', // When a LangSmith experiment run completes
  EMAIL_AI_STUDIO_WEBHOOK = 'email-ai-studio-webhook',
  MULTILINGUAL_TRANSLATION = 'multilingual-translation', // When a reviewer triggers translation in the Train AI fact-checking modal
  CONTACT_LOOKUP_REAL_TIME = 'contact-lookup-real-time', // Real-time company name disambiguation in a ZvdZ chat flow
  INTENT_CHECK_REAL_TIME_CLASSIFICATION = 'intent-check-real-time-classification', // Real-time intent-check classifier that runs once per intent-check block call
  PII_ANONYMIZATION_REAL_TIME = 'pii-anonymization-real-time', // Real-time PII anonymization that runs once per LLM block call
}

export type TLLMUsageTranslation = {
  question: string;
  answer: string;
  sourceLang: string;
};

// * Pipeline stage emitted during a streaming LLM response.
// * Searching - vector search is running
// * Generating - docs ready, LLM call started
export enum LLMStreamStage {
  Searching = 'searching',
  Generating = 'generating',
}

// * Milliseconds the webclient typewriter takes to reveal one character during a
// * streaming LLM response (one character per tick). Shared so Core can size the
// * render-complete ack timeout to how long the widget animation can actually
// * take - keep this the single source of truth for both sides.
export const STREAM_TYPEWRITER_SPEED_MS = 25;
